/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import ReducerCommon from './reducer-common';

export default ReducerCommon;



// WEBPACK FOOTER //
// ./src/reducers/common/index.js